import React from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { Link } from 'src/router/components';
import { RouteComponentProps } from 'src/router/types';
import { withRouter } from 'src/router/utils';

import messages from './i18n';

export const DashboardLink = React.memo(() => (
  <Link to="/dashboard/overview">
    <FormattedMessage {...messages.dashboardLinkText} />
  </Link>
));

// @ts-ignore TODO: fix `withRouter` type to understand that RouteComponentProps are being passed through
export const PreviousPageLink: React.FC = withRouter(
  React.memo((props: RouteComponentProps) => (
    <CustomThemeButton
      spacing="none"
      appearance="link"
      onClick={props.history.goBack}
    >
      <FormattedMessage {...messages.previousPageLinkText} />
    </CustomThemeButton>
  ))
);
